import CertsSidePanelBody from './CertsSidePanelBody';

export default CertsSidePanelBody;
